function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.pageOverlay = document.querySelector('.PageOverlay')
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
			root: null,
			rootMargin: '200px 0px 0px 0px',
		});
		this.poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!this.poster) return;
		this.poster.addEventListener('click', this.loadContent.bind(this));
		this.addEventListener('click', this.togglePlay.bind(this));
		this.observer.observe(this);
	}

	handleIntersection(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				this.loadContent(false);
				this.observer.unobserve(this);
			}
		});
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
			if (focus) deferredElement.focus();
		}
	}

	togglePlay() {
		const deferredMedia = this.querySelector('video, model-viewer, iframe');
		if (!deferredMedia) return;

		const isYouTube = deferredMedia.src.includes('youtube.com');
		const isVimeo = deferredMedia.src.includes('vimeo.com');

		if (deferredMedia.tagName === 'IFRAME') {
			const iframeWindow = deferredMedia.contentWindow;
			if (iframeWindow && iframeWindow.postMessage) {
				if (this.iframePaused) {
					if (isYouTube) {
						iframeWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
					} else if (isVimeo) {
						iframeWindow.postMessage('{"method":"play"}', '*');
					}
					this.iframePaused = false;
				} else {
					if (isYouTube) {
						iframeWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
					} else if (isVimeo) {
						iframeWindow.postMessage('{"method":"pause"}', '*');
					}
					this.iframePaused = true;
				}
			}
		} else {
			deferredMedia.paused ? deferredMedia.play() : deferredMedia.pause();
		}
		this.toggleButton();
	}

	toggleButton() {
		this.poster.classList.toggle('paused');
	}
}

customElements.define('deferred-media', DeferredMedia);

// const videos = document.querySelectorAll('deferred-media');
// window.clicked = false

// document.addEventListener('scroll', function () {
//   videos.forEach((item) => {
//     if (isInViewport(item)) {
//       if (!window.clicked) {
//         item.loadContent()
//         item.querySelector('[id^="Deferred-Poster-"]').click()
//         window.clicked = true
//       }
//     } else {
//       item.querySelector('.js-vimeo')?.contentWindow.postMessage('{"method":"pause"}', '*');
//     }
//   })
//
// }, {
//   passive: true
// });

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const oneTimePrice = html.getElementById('one-time-price')
        const subscriptionPrice = html.getElementById('selling-plan-price')
        
        if (subscriptionPrice !== null) {
          document.getElementById('one-time-price').innerHTML = oneTimePrice.innerHTML
          document.getElementById('selling-plan-price').innerHTML = subscriptionPrice.innerHTML
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        document.dispatchEvent(new CustomEvent('variantChange', { detail: this.currentVariant}));

        const price = document.getElementById(`price-${this.dataset.section}`);
        

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    //const slider = this.querySelector('[data-swiper-config]');
    //if (!slider) return;
    //slider.addEventListener('click', this.initSlider.bind(this));
		this.swiperInstance = null;
		this.video = this.querySelector('video');
		this.autoplayEnabled = this.getAttribute('data-slider-autoplay') === 'true';
    this.initSlider();
  }
  
  initSlider() {
    const sliderData = JSON.parse(this.getAttribute('data-swiper-options'))
    
    if (this.getAttribute('data-thumbnails')) {
      const thumbnails_element = document.querySelector('.product-thumbnails')
      const thumbnails_options = JSON.parse(this.getAttribute('data-thumbnails'))
      const thumbnailsSwiper = new Swiper(thumbnails_element, thumbnails_options)
      
      sliderData.thumbs = {
        swiper: thumbnailsSwiper,
        autoScrollOffset: 1
      }
		}
		
		

		this.swiperInstance = new Swiper(this, sliderData);

		if (this.classList.contains('content-slideshow--slider')) {
			this.querySelectorAll('.content-slideshow__item').forEach(item => {
				item.addEventListener('mouseenter', () => {
					this.swiperInstance.allowTouchMove = false;
					if (this.swiperInstance.mousewheel) {
						this.swiperInstance.mousewheel.disable();
					}
				});
				item.addEventListener('mouseleave', () => {
					this.swiperInstance.allowTouchMove = true;
					if (this.swiperInstance.mousewheel) {
						this.swiperInstance.mousewheel.enable();
					}
				});
			});
		}

		if (this.video) {
			this.video.addEventListener('canplaythrough', () => {
				this.video.play();
			});
		}
  }
	stopSlider() {
		if (this.swiperInstance && this.swiperInstance.autoplay) {
			this.swiperInstance.autoplay.stop();
		}
	}

	startSlider() {
		if (this.swiperInstance && this.swiperInstance.autoplay) {
			this.swiperInstance.autoplay.start();
		}
	}
}
document.addEventListener("DOMContentLoaded", function () {
	$('.btn--read-more').on('click', function (e) {
		const target = $(this).attr('data-target');
		const sliderId = $(this).attr('data-slider');
		const swiperElement = document.querySelector(`.content-slideshow--slider[data-slider="${sliderId}"]`);

		e.preventDefault();
		$(`.content-slideshow__popup[data-id="${target}"]`).addClass('opened');
		$('body').css('overflow', 'hidden');
		$('.content-slideshow__text').css('overflow-y', 'auto');
		if (swiperElement) {
			const autoplayEnabled = swiperElement.getAttribute('data-slider-autoplay') === 'true';

			if (autoplayEnabled) {
				swiperElement.stopSlider();
			}
		}
	});

	class PopupBlock extends HTMLElement {
		constructor() {
			super();

			this.itemPopup = this.querySelector('.content-slideshow__text');

			this.addEventListener('click', (e) => {
				if (e.target.closest('.close-popup') || !this.itemPopup.contains(e.target)) {
					this.closePopup.bind(this)();
					document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
				}
			});
		}

		closePopup() {
			const sliderId = this.getAttribute('data-slider');
			const swiperElement = document.querySelector(`swiper-slider[data-slider="${sliderId}"]`);

			this.classList.remove('opened');
			$('body').css('overflow', 'auto');
			if (swiperElement) {
				const autoplayEnabled = swiperElement.getAttribute('data-slider-autoplay') === 'true';
				if (autoplayEnabled) {
					swiperElement.startSlider();
				}
			}
		}
	}

	if (!customElements.get('popup-block')) {
		customElements.define('popup-block', PopupBlock);
	}
})
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('[data-accordion-content]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => {
      (Array.from(e.target.classList).indexOf('accordion__event-prevent') > 0) ? e.preventDefault() : this.onClick(e)
    });
  }
  
  onClick(e) {
    e.preventDefault();
    var parent = e.target.closest('[data-accordion-collapseble]');
    
    if (parent) {
      parent.querySelectorAll('[data-accordion-opener][open]').forEach((el) => {
        
        if (el != this.el ) {
          const startHeight = `${el.offsetHeight}px`;
          const endHeight = `${el.querySelector('summary').offsetHeight}px`;
          
          el.animation = el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 300,
            easing: 'linear'
          });
          
          el.animation.onfinish = () => el.removeAttribute('open');
        }
      });
    }
    
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel()
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'linear'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    if (this.animation) this.animation.cancel()
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'linear'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('[data-accordion-opener]').forEach((el) => {
  new Accordion(el);
});

customElements.define('swiper-slider', SwiperSlider);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.cartDrawer = document.getElementById('sidebar-cart')
    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)
    this.cartIcon = document.querySelector('#cart-icon-bubble')
    this.cartScrollable = document.querySelector('[data-scrollable]')
    this.pageOverlay = document.querySelector('.PageOverlay')
    
    this.cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    })
  
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.querySelectorAll('[data-action="close-cart"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  
    document.documentElement.style.setProperty('--drawer-footer-and-header-height', (document.querySelector('#sidebar-cart .Drawer__Footer')?.getBoundingClientRect().height + document.querySelector('#sidebar-cart .Drawer__CartHeader').getBoundingClientRect().height + 30) + 'px');
  
    if (new URLSearchParams(location.search).has('cart')) {
      var urlParams = new URLSearchParams(location.search);
      urlParams.delete('cart');
    
      history.replaceState(null, null, location.href.replace(location.search, '?' + urlParams));
      this.open()
    }
  }
  
  open() {
    this.pageOverlay.classList.add('is-visible')
    this.cartDrawer.setAttribute('aria-hidden', 'false');
  
    bodyScrollLock.disableBodyScroll(this.cartScrollable)
    
    
    this.cartDrawer.addEventListener('transitionend', () => {
      this.cartDrawer.focus();
      trapFocus(this.cartDrawer);
    }, { once: true });
    
    document.body.addEventListener('click', this.onBodyClick);
  }
  
  close() {
    this.cartDrawer.setAttribute('aria-hidden', 'true');
    this.pageOverlay.classList.remove('is-visible')
  
    document.body.removeEventListener('click', this.onBodyClick);
    
    removeTrapFocus(this.activeElement);
    
    bodyScrollLock.clearAllBodyScrollLocks()
  }
  
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this && !target.closest('cart-drawer') && !target.closest('#cart-icon-bubble')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
  
  renderCart(responseHTML, openCart) {
    if (!responseHTML) {
      return
    }
    
    const cartBody = document.querySelector('.Drawer__CartListWrapper')
    const cartHeader = document.querySelector('.Drawer__CartHeaderTitle')
    const freeShippingMessage = document.querySelector('.FreeShipping__Message')
    const progressLine = document.querySelector('.FreeShipping__ProgressLine')
    const cartFooter = document.querySelector('.Drawer__Footer')
    const cartBodyNew = responseHTML.querySelector('.Drawer__CartListWrapper').innerHTML
    const cartHeaderNew = responseHTML.querySelector('.Drawer__CartHeaderTitle').innerHTML
    const freeShippingMessageNew = responseHTML.querySelector('.FreeShipping__Message').innerHTML
    const progressLineNew = responseHTML.querySelector('.FreeShipping__ProgressLine').getAttribute('style')
    const cartFooterNew = responseHTML.querySelector('.Drawer__Footer')
    const cartCountNew = responseHTML.getElementById('item-count')
    const cartCountBubble = document.querySelector('.header__icon .cart-count-bubble')
  
    if (cartCountNew !== null) {
      cartCountBubble.style.display = 'block'
      
      cartCountBubble.querySelector('[aria-hidden="true"]').innerHTML = cartCountNew.getAttribute('data-count')
    } else {
      cartCountBubble.style.display = 'none'
    }
    
    cartBody.innerHTML = cartBodyNew
    cartHeader.innerHTML = cartHeaderNew
    freeShippingMessage.innerHTML = freeShippingMessageNew
    progressLine.style = progressLineNew
    
    if (cartFooter == null) {
      document.querySelector('.Drawer__CartWrapper').append(cartFooterNew)
    } else {
      if (cartFooterNew !== null) {
        cartFooter.innerHTML = cartFooterNew.innerHTML
        cartFooter.style.display = 'block'
      } else {
        cartFooter.style.display = 'none'
      }
    }
    
    if (openCart) {
      this.open()
    }
  }
  
}

customElements.define('cart-drawer', CartDrawer);


class CartItems extends HTMLElement {
  constructor() {
    super()
  
    this.addEventListener('change', this.updateQuantity.bind(this))
    this.cartDrawer = document.querySelector('cart-drawer')
  }
  
  updateQuantity(event) {
    event.preventDefault()
    
    const sectionsId = 'cart-drawer'
    const config = fetchConfig('javascript')
    const id = event.target.getAttribute('data-line-key')
    let quantity
    
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    
    if (event.target.tagName === 'INPUT') {
      quantity = parseInt(Math.max(parseInt(event.target.value) || 1, 1));
    } else {
      quantity = parseInt(event.target.getAttribute('data-quantity'));
    }
    
    config.body = JSON.stringify({
      updates: {
        [id]: quantity,
      },
      sections: sectionsId,
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        const cartHTML = new DOMParser().parseFromString(json.sections[sectionsId], 'text/html');
        
        this.cartDrawer.renderCart(cartHTML, false)
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

customElements.define('cart-items', CartItems);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.closest('cart-items').updateQuantity(event, false);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


var rellax = new Rellax('.rellax', {
  breakpoints: [576, 768, 1201],
  center: true,
});

$(document).ready(function () {
  if (!$('body').hasClass('Customizer') && !$('.IndexHero').length)  {
    AOS.init({
      duration: 800
    });
  }
  
  $('.content-slideshow__text').each(function() {
    const scrollHeight = $(this)[0].scrollHeight;
    const clientHeight = $(this)[0].clientHeight;
    
    if ( scrollHeight > clientHeight && $(window).width() < 1000 ) {
      $(this).parent().find('.btn--read-more').show();
    }
  });

  $('.read-more--paragraph').on('click', function (e) {
    e.preventDefault();
    $(this).hide()
    const target = $(this).attr('data-target')
    
    $(this).parent().find(`[data-id="${target}"]`).slideToggle()
  })
  
  window.addEventListener("message", function(event) {
    rellax?.refresh && rellax?.refresh();
  })
  
	function handleDropdownClick(e) {
		e.preventDefault();

		const $trigger = $(this);
		const isMobileOnly = $trigger.is('[mobile-accordion]');
		const isMobile = window.innerWidth < 768;

		if (isMobileOnly && !isMobile) return;

		const $currentLi = $trigger.closest('li');
		const $parentUl = $currentLi.closest('ul');

		$parentUl.find('li.opened').not($currentLi).removeClass('opened').find('.footer__childmenu').slideUp();
		$currentLi.toggleClass('opened').find('.footer__childmenu').slideToggle();
	}

	$('.footer-dropdown').on('click', handleDropdownClick);

	function handleResize() {
		const isDesktop = window.innerWidth >= 768;

		$('.footer-dropdown[mobile-accordion]').each(function () {
			const $li = $(this).closest('li');
			const $childMenu = $li.find('.footer__childmenu');

			if (isDesktop) {
				$li.addClass('opened');
				$childMenu.stop(true, true).show();
			} else {
				$li.removeClass('opened');
				$childMenu.stop(true, true).hide();
			}
		});
	}

	$(window).on('resize', handleResize);
	handleResize();

	
	$('[accordion-dropdown]').on('click', function (e) {
		e.preventDefault();
		const $clickedItem = $(this).closest('li');
		const $accordion = $(this).closest('accordion');

		$accordion.find('li').not($clickedItem).removeClass('opened').find('[accordion-text]').slideUp();
		$clickedItem.toggleClass('opened').find('[accordion-text]').slideToggle();
	});

  
  $(document).on('click', '.custom-select__header', function (e) {
    e.preventDefault();
    
    $(this).parent().toggleClass('opened').find('.custom-select__dropdown').slideToggle()
  })
  
  $(document).on('click', '.custom-select__item', function (e) {
    e.preventDefault()
    const $select = $(this).parents('.custom-select')
    const value = $(this).attr('data-value')
    const $productOptionSelect = $(`#${$select.attr('data-target')}`)
    
    $productOptionSelect.val(value).parents('variant-selects')[0].onVariantChange()
    $select.find('.custom-select__item').removeClass('selected')
    $(this).addClass('selected')
    $select.find('.custom-select__value').html(value)
    $select.find('.custom-select__dropdown').slideUp()
    $select.removeClass('opened')
  })
  
  
  $(document).on('shopify:section:load', function () {
    const swipers = document.querySelectorAll('swiper-slider')
    
      swipers.forEach((slider) => {
        slider.initSlider()
      })
  });
  
  $(document).click(function(event) {
    if (!$(event.target).closest(".custom-select").length && $('.custom-select__dropdown:visible').length) {
      $('.custom-select__dropdown').slideUp().parents('.custom-select').removeClass('opened')
    }
  });
  
  zoomInit()
})

function zoomInit() {
  if (document.querySelector('.Product__Gallery-Zoom-Enabled')) {
    document.querySelectorAll('.Product__Gallery-Zoom-Enabled .swiper-slide').forEach(item => {
			new zoomComponent(item);
    })
  }
}
class zoomComponent {
	constructor(elem) {
    this.elem = elem;
    let original;
    let wrapper;
    
    original = elem.querySelector('img');
    wrapper = elem;
  
    elem.addEventListener('mousemove', (e) => {
      this.mousemoveListener(e, elem, original, wrapper);
    }, false)
    
    elem.addEventListener('mouseleave', (e) => {
      this.mouseleaveListener(elem);
    }, false)
  }
  
  mousemoveListener(e, item, original, wrapper) {
    let zoom = item.querySelector('.Product__Gallery-Zoom');
    const scale = item.closest('[data-zoom-scale]').getAttribute('data-zoom-scale');
    const offsetLeftCalc = wrapper.getBoundingClientRect().left;
    
    let offsetTopCalc = item.closest('#MainContent').offsetTop + 57;
		
    const x = ((e.pageX - offsetLeftCalc) / original.offsetWidth) * 100;
    const y = ((e.pageY - offsetTopCalc) / original.offsetHeight) * 100;
    
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'Product__Gallery-Zoom';
      item.insertAdjacentElement('beforeend', zoom);
    }
    
    zoom.style.cssText = `
      background-image: url('${original.src}');
      background-size: ${scale * 100}%;
      background-position: ${x}% ${y}%;
      opacity: 1;`;
  }
  
  mouseleaveListener(item) {
    const zoom = item.querySelector('.Product__Gallery-Zoom');
    zoom.style.opacity = 0;
  }
}

const galleryImages = document.querySelectorAll('.follow__gallery-column img');
const popupImg = document.getElementById('popup-img');
const popup = document.getElementById('popup');
const popupPrev = document.getElementById('popup-prev');
const popupNext = document.getElementById('popup-next');
const popupCloseButton = document.getElementById('popup-close');
let currentImageIndex = 0;



function openPopup(imageSrc) {
  popupImg.src = imageSrc;
  popup.style.display = 'block';
  header.classList.toggle('hidden');
  document.addEventListener('click', handleOutsideClick);
  body.classList.toggle('lock');
}

function closePopup() {
  popup.style.display = 'none';
  header.classList.remove('hidden');
  document.removeEventListener('click', handleOutsideClick);
}


function showPrevImage() {
  currentImageIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
  popupImg.src = galleryImages[currentImageIndex].src;
}

function showNextImage() {
  currentImageIndex = (currentImageIndex + 1) % galleryImages.length;
  popupImg.src = galleryImages[currentImageIndex].src;
}

galleryImages.forEach((image, index) => {
  image.addEventListener('click', () => {
    currentImageIndex = index;
    openPopup(image.src);
  });
});

popupCloseButton?.addEventListener('click', closePopup);
popupPrev?.addEventListener('click', showPrevImage);
popupNext?.addEventListener('click', showNextImage);
class ZoomPopup extends HTMLElement {
	constructor() {
		super();
		window.addEventListener('load', () => {
			this.galleryId = this.getAttribute('data-id');
			this.slides = this.querySelectorAll('.zoom-popup__slide');
			this.bgColor = this.getAttribute('data-bg') || '#f5f5f5'; 
			this.createDuplicateSlider();
			this.addClickListeners();
		});
	}

	createDuplicateSlider() {
		const sliderOverlay = document.createElement('div');
		sliderOverlay.className = `duplicat-slider__overlay ${this.galleryId}-overlay`;

		const sliderPopup = document.createElement('div');
		sliderPopup.className = `duplicat-slider__popup hidden ${this.galleryId}-popup`;

		const sliderContainer = document.createElement('div');
		sliderContainer.className = `duplicat-slider swiper ${this.galleryId}-slider`;
		sliderContainer.style.backgroundColor = this.bgColor;

		const sliderWrapper = document.createElement('div');
		sliderWrapper.className = 'duplicat-slider__wrapper swiper-wrapper';

		if (this.slides.length === 1) {
			const singleSlide = this.slides[0].cloneNode(true);
			singleSlide.classList.add('duplicat-slider__slide', 'swiper-slide');
			sliderWrapper.appendChild(singleSlide);
			sliderContainer.classList.add('single-image-duplicat-slider');
		} else {
			this.slides.forEach(slide => {
				const slideClone = slide.cloneNode(true);
				slideClone.classList.add('duplicat-slider__slide', 'swiper-slide');
				this.clearSlideStyles(slideClone);
				sliderWrapper.appendChild(slideClone);
			});

			const navPrev = document.createElement('div');
			navPrev.className = `duplicat-slider__nav-prev ${this.galleryId}-nav-prev`;
			sliderContainer.appendChild(navPrev);

			const navNext = document.createElement('div');
			navNext.className = `duplicat-slider__nav-next ${this.galleryId}-nav-next`;
			sliderContainer.appendChild(navNext);
		}

		const closeButton = document.createElement('button');
		closeButton.className = `duplicat-slider__close ${this.galleryId}-close`;
		sliderContainer.appendChild(closeButton);

		sliderContainer.appendChild(sliderWrapper);
		sliderPopup.appendChild(sliderContainer);

		const sectionContainer = this.closest('.shopify-section');
		sectionContainer.insertAdjacentElement('afterend', sliderPopup);
		sectionContainer.insertAdjacentElement('afterend', sliderOverlay);

		this.initSlider(sliderContainer);

		sliderOverlay.addEventListener('click', () => {
			this.closeSlider();
		});

		closeButton.addEventListener('click', () => {
			this.closeSlider();
		});
	}

	clearSlideStyles(slide) {
		slide.style.opacity = '';
		slide.style.transform = '';
		slide.style.width = '';
		slide.style.height = '';
	}

	initSlider(container) {
		if (typeof Swiper !== 'undefined') {
			this.swiperInstance = new Swiper(container, {
				loop: false,
				slidesPerView: 1,
				centeredSlides: true,
				updateOnWindowResize: true,
				watchOverflow: true,
				navigation: {
					nextEl: `.${this.galleryId}-nav-next`,
					prevEl: `.${this.galleryId}-nav-prev`,
				},
				breakpoints: {
					767: {
						slidesPerView: "auto",
					},
				},
			});
		}
	}

	closeSlider() {
		const sliderPopup = document.querySelector(`.${this.galleryId}-popup`);
		const sliderOverlay = document.querySelector(`.${this.galleryId}-overlay`);

		if (sliderPopup && sliderOverlay) {
			sliderPopup.classList.add('hidden');
			sliderOverlay.classList.remove('shown');
		}
	}


	addClickListeners() {
		this.slides.forEach(slide => {
			slide.addEventListener('click', () => {
				const sliderPopup = document.querySelector(`.${this.galleryId}-popup`);
				const sliderOverlay = document.querySelector(`.${this.galleryId}-overlay`);

				if (event.target.closest('.product-gallery__badge')) {
					return;
				}

				if (sliderPopup && sliderOverlay) {
					sliderPopup.classList.remove('hidden');
					sliderOverlay.classList.add('shown');

					const index = slide.getAttribute('data-index');
					if (this.swiperInstance) {
						this.swiperInstance.slideTo(parseInt(index, 10) || 0);
					}
				}
			});
		});
	}
}

if (!customElements.get('zoom-popup')) {
	customElements.define('zoom-popup', ZoomPopup);
}


// document.addEventListener('DOMContentLoaded', function () {
// 	const imageWrappers = document.querySelectorAll('.image-wrapper');
// 	let offsetX, offsetY, initialX, initialY, isDragging = false, clickCount = 0, lastClickTime = 0;

// 	imageWrappers.forEach(wrapper => {
// 		const mainImage = wrapper.querySelector('.main-image');
// 		let isZoomed = false, zoomedImage;

// 		function handleDrag(event, type) {
// 			if (!isZoomed) return;
// 			event.preventDefault();
// 			const touch = type === 'touch' ? event.touches[0] : event;
// 			const newOffsetX = touch.clientX - initialX;
// 			const newOffsetY = touch.clientY - initialY;

// 			const maxOffsetX = wrapper.offsetWidth / 2;
// 			const maxOffsetY = (wrapper.offsetHeight / 2) - 50;
// 			const minOffsetY = ((zoomedImage.offsetHeight )/ 2) + 50;

// 			offsetX = Math.max(-maxOffsetX, Math.min(newOffsetX, maxOffsetX));
// 			offsetY = Math.max(-minOffsetY, Math.min(newOffsetY, maxOffsetY));

// 			updatePosition(offsetX, offsetY);
// 		}

// 		function startDrag(event) {
// 			if (isZoomed) {
// 				isDragging = true;
// 				const touch = event.type === 'touchstart' ? event.touches[0] : event;
// 				initialX = touch.clientX - offsetX;
// 				initialY = touch.clientY - offsetY;
// 			}
// 		}

// 		function endDrag() {
// 			isDragging = false;
// 		}

// 		function updatePosition(x, y) {
// 			if (isZoomed) {
// 				zoomedImage.style.transform = `translate(${x}px, ${y}px)`;
// 			}
// 		}

// 		function createZoomedImage() {
// 			zoomedImage = document.createElement('img');
// 			offsetX = 0;
// 			offsetY = 0;

// 			zoomedImage.src = mainImage.src;
// 			zoomedImage.classList.add('main-image', 'main-image--zoomed');
// 			zoomedImage.style.width = (mainImage.offsetWidth * 2) + 'px';
// 			zoomedImage.style.height = (mainImage.offsetHeight * 2) + 'px';

// 			wrapper.insertBefore(zoomedImage, mainImage.nextSibling);
// 			addZoomedImageEventListeners();
// 		}

// 		function addZoomedImageEventListeners() {
// 			['mousedown', 'touchstart'].forEach(event => zoomedImage.addEventListener(event, startDrag));
// 			['mousemove', 'touchmove'].forEach(event => zoomedImage.addEventListener(event, (e) => handleDrag(e, event.includes('touch') ? 'touch' : 'mouse')));
// 			['mouseup', 'touchend'].forEach(event => zoomedImage.addEventListener(event, endDrag));

// 			zoomedImage.addEventListener('click', handleClick);
// 		}

// 		function handleClick(event) {
// 			const currentTime = new Date().getTime();
// 			const timeSinceLastClick = currentTime - lastClickTime;

// 			if (timeSinceLastClick < 300) {
// 				clickCount++;
// 				if (clickCount === 2) {
// 					isZoomed ? hideZoomedImage() : showZoomedImage();
// 				}
// 			} else {
// 				clickCount = 1;
// 			}

// 			lastClickTime = currentTime;
// 			event.stopPropagation();
// 		}

// 		function showZoomedImage() {
// 			if (!isZoomed) {
// 				if (!zoomedImage) createZoomedImage();
// 				mainImage.classList.add('hidden');
// 				zoomedImage.classList.remove('hidden');
// 				isZoomed = true;
// 				wrapper.classList.add('ingredients__mobile-zoom');
// 				wrapper.style.zIndex = window.innerWidth < 767 ? 3 : '';
// 			}
// 		}

// 		function hideZoomedImage() {
// 			mainImage.classList.remove('hidden');
// 			zoomedImage.classList.add('hidden');
// 			updatePosition(0, 0);
// 			isZoomed = false;
// 			wrapper.style.zIndex = '';
// 			wrapper.classList.remove('ingredients__mobile-zoom');
// 		}

// 		mainImage.addEventListener('click', handleClick);
// 		document.addEventListener('click', function (event) {
// 			if (isZoomed && !wrapper.contains(event.target)) hideZoomedImage();
// 		});
// 	});
// });